import { render, staticRenderFns } from "./Formatter.vue?vue&type=template&id=344affd2&"
import script from "./Formatter.vue?vue&type=script&lang=ts&"
export * from "./Formatter.vue?vue&type=script&lang=ts&"
import style0 from "./Formatter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports